/* Yuvrit — Ayurvedic Fertility Detox landing page (Shopify build)
   Lead pipeline matches the sitewide popup exactly:
     1. Google Apps Script sheet  (full payload)
     2. Vercel Bigin API          (mapped payload)
   Differences: formName is "Fertility_ LandingPage1" and helpCategory is
   locked to "Fertility support" (there is no dropdown on this page).
*/

(function () {
  var YUVRIT = window.YUVRIT_CONFIG || {};

  var BIGIN_ENDPOINT =
    YUVRIT.biginEndpoint || "https://yuvrit-bigin-api.vercel.app/api/bigin";
  var SHEET_ENDPOINT = YUVRIT.sheetEndpoint || "";
  var FORM_NAME = YUVRIT.formName || "Fertility_ LandingPage1";
  var HELP_CATEGORY = YUVRIT.helpCategory || "Fertility support";
  var THANK_YOU_URL = YUVRIT.thankYouUrl || "/pages/fertility-thank-you";

  // "phone" is the number shown on the thank-you page during business hours.
  // Online consultations have no clinic of their own, so they fall back to the
  // main line — change ONLINE_PHONE if you set up a dedicated number.
  var ONLINE_PHONE = "8050787854";

  var CENTRES = {
    indiranagar: {
      name: "Indiranagar - In Person",
      short: "Indiranagar",
      bigin: "Indiranagar",
      phone: "8050787373",
    },
    hsr: {
      name: "HSR Layout - In Person",
      short: "HSR Layout",
      bigin: "HSR Layout",
      phone: "8050787854",
    },
    aecs: {
      name: "Whitefield (AECS) - In Person",
      short: "Whitefield (AECS)",
      bigin: "Whitefield (AECS)",
      phone: "8050787676",
    },
    online: {
      name: "Online Video Consultation",
      short: "Yuvrit Care",
      bigin: "Online Video Consultation",
      phone: ONLINE_PHONE,
    },
  };

  /* ==========================================================
     TRACKING — same collection logic as the sitewide popup
     ========================================================== */

  var trackingData = {};
  var pageURL = window.location.href;

  function getUrlParam(param) {
    return new URLSearchParams(window.location.search).get(param) || "";
  }

  function getDeviceType() {
    var ua = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipod|windows phone/.test(ua)) return "Mobile";
    if (/tablet|ipad|android/.test(ua)) return "Tablet";
    return "Desktop";
  }

  function getBrowserInfo(ua) {
    if (ua.includes("Edge")) return "Edge";
    if (ua.includes("OPR") || ua.includes("Opera")) return "Opera";
    if (ua.includes("Chrome")) return "Chrome";
    if (ua.includes("Safari")) return "Safari";
    if (ua.includes("Firefox")) return "Firefox";
    return "Other";
  }

  function getOSInfo(ua) {
    if (ua.includes("Windows")) return "Windows";
    if (ua.includes("Android")) return "Android";
    if (ua.includes("iPhone") || ua.includes("iPad") || ua.includes("iOS")) return "iOS";
    if (ua.includes("Mac")) return "macOS";
    if (ua.includes("Linux")) return "Linux";
    return "Unknown";
  }

  function getGAClientId() {
    if (window.gtag) {
      return localStorage.getItem("_ga") || "Not Available";
    }
    return "GA4 Not Found";
  }

  function classifyTrafficSource(referrer, utmSource) {
    if (utmSource) return "UTM: " + utmSource;
    if (!referrer || referrer === "Direct") return "Direct";
    if (referrer.includes("google")) return "Organic Search (Google)";
    if (referrer.includes("facebook")) return "Social (Facebook)";
    if (referrer.includes("instagram")) return "Social (Instagram)";
    if (referrer.includes("twitter")) return "Social (Twitter)";
    if (referrer.includes("linkedin")) return "Social (LinkedIn)";
    try {
      return "Referral: " + new URL(referrer).hostname;
    } catch (err) {
      return "Referral";
    }
  }

  function fetchIPLocation() {
    return fetch("https://ipapi.co/json/")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        return {
          ip: d.ip,
          country: d.country_name || "N/A",
          region: d.region || "N/A",
          city: d.city || "N/A",
          lat: d.latitude || "N/A",
          lon: d.longitude || "N/A",
          isp: d.org || "N/A",
          timezone: d.timezone || "N/A",
        };
      });
  }

  function collectTracking() {
    var ua = navigator.userAgent;

    trackingData.formName = FORM_NAME;
    trackingData.pageUrl = pageURL;
    trackingData.pageTitle = document.title;
    trackingData.referrer = document.referrer || "Direct";

    trackingData.utmSource = getUrlParam("utm_source");
    trackingData.utmMedium = getUrlParam("utm_medium");
    trackingData.utmCampaign = getUrlParam("utm_campaign");
    trackingData.utmContent = getUrlParam("utm_content");
    trackingData.utmTerm = getUrlParam("utm_term");
    trackingData.gclid = getUrlParam("gclid");
    trackingData.fbclid = getUrlParam("fbclid");

    trackingData.userAgent = ua;
    trackingData.deviceType = getDeviceType();
    trackingData.browser = getBrowserInfo(ua);
    trackingData.operatingSystem = getOSInfo(ua);
    trackingData.screenResolution = window.screen.width + "x" + window.screen.height;
    trackingData.viewportSize = window.innerWidth + "x" + window.innerHeight;
    trackingData.language = navigator.language || "unknown";
    trackingData.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    trackingData.sessionStartTime =
      sessionStorage.getItem("sessionStart") || new Date().toISOString();
    if (!sessionStorage.getItem("sessionStart")) {
      sessionStorage.setItem("sessionStart", trackingData.sessionStartTime);
    }
    trackingData.formOpenedTime = new Date().toISOString();

    trackingData.gaClientId = getGAClientId();
    trackingData.gtmContainerId = window.gtag ? "GTM Available" : "GTM Not Found";

    trackingData.trafficSource = classifyTrafficSource(
      trackingData.referrer,
      trackingData.utmSource
    );
    trackingData.landingPage = sessionStorage.getItem("landingPage") || pageURL;
    if (!sessionStorage.getItem("landingPage")) {
      sessionStorage.setItem("landingPage", pageURL);
    }

    // IP lookup is best-effort and never blocks the form
    trackingData.ipAddress = "N/A";
    trackingData.country = "N/A";
    trackingData.city = "";
    fetchIPLocation()
      .then(function (loc) {
        trackingData.ipAddress = loc.ip;
        trackingData.country = loc.country;
        trackingData.region = loc.region;
        trackingData.city = loc.city;
        trackingData.latitude = loc.lat;
        trackingData.longitude = loc.lon;
        trackingData.isp = loc.isp;
        trackingData.timezone_location = loc.timezone;
      })
      .catch(function (err) {
        console.warn("Could not fetch IP location:", err);
      });
  }

  /* ==========================================================
     UI
     ========================================================== */

  function openModal() {
    var modal = document.getElementById("leadModal");
    if (!modal) return;
    modal.classList.add("open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    trackingData.formOpenedTime = new Date().toISOString();
    var name = document.getElementById("fullName");
    if (name) name.focus();
  }

  function closeModal() {
    var modal = document.getElementById("leadModal");
    if (!modal) return;
    modal.classList.remove("open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function initLanding() {
    collectTracking();

    document.querySelectorAll(".js-open-form").forEach(function (btn) {
      btn.addEventListener("click", openModal);
    });

    var modal = document.getElementById("leadModal");
    var closeBtn = document.getElementById("closeModal");
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (modal) {
      modal.addEventListener("click", function (e) {
        if (e.target === modal) closeModal();
      });
    }
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeModal();
    });

    var schedBtn = document.querySelector("[data-schedule]");
    var schedule = document.getElementById("schedule");
    if (schedBtn && schedule) {
      schedBtn.addEventListener("click", function () {
        var open = schedule.classList.toggle("open");
        schedBtn.textContent = open
          ? "Hide treatment schedule"
          : "View treatment schedule";
      });
    }

    document.querySelectorAll(".video-wrap").forEach(function (wrap) {
      var video = wrap.querySelector("video");
      var btn = wrap.querySelector(".mute-btn");
      if (!video || !btn) return;
      btn.addEventListener("click", function () {
        document.querySelectorAll(".video-wrap video").forEach(function (other) {
          if (other !== video) {
            other.muted = true;
            var otherBtn = other.parentElement.querySelector(".mute-btn");
            if (otherBtn) otherBtn.textContent = "🔇";
          }
        });
        video.muted = !video.muted;
        btn.textContent = video.muted ? "🔇" : "🔊";
      });
    });

    var phoneInput = document.getElementById("phone");
    if (phoneInput) {
      phoneInput.setAttribute("maxlength", "10");
      phoneInput.addEventListener("input", function () {
        this.value = this.value.replace(/[^0-9]/g, "").slice(0, 10);
      });
    }

    var form = document.getElementById("leadForm");
    if (form) form.addEventListener("submit", handleSubmit);
  }

  /* ==========================================================
     SUBMIT
     ========================================================== */

  function handleSubmit(e) {
    e.preventDefault();

    var form = e.currentTarget;
    var errorEl = document.getElementById("formError");
    var fullName = document.getElementById("fullName").value.trim();
    var phoneRaw = document.getElementById("phone").value.replace(/\D/g, "");
    var email = document.getElementById("email").value.trim();
    var centre = document.getElementById("centre").value;
    var consent = document.getElementById("consent").checked;

    if (fullName.length < 2) {
      errorEl.textContent = "Please enter your full name.";
      return;
    }
    if (!/^[0-9]{10}$/.test(phoneRaw)) {
      errorEl.textContent = "Please enter a valid 10-digit phone number.";
      return;
    }
    if (!centre) {
      errorEl.textContent = "Please select a consultation type.";
      return;
    }
    if (!consent) {
      errorEl.textContent = "Please agree to be contacted by Yuvrit.";
      return;
    }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.textContent = "Please enter a valid email, or leave it blank.";
      return;
    }

    errorEl.textContent = "";

    var centreInfo = CENTRES[centre] || {};
    var centreLabel = centreInfo.name || centre;

    // Value written to Bigin's Pref_Branch (Preferred Clinic) field. Clinics send
    // the plain branch name; online sends "Online Video Consultation".
    var branchValue = centreInfo.bigin || centre;

    // Web_Notes carries the online consultation only. For in-person bookings the
    // branch is already in Pref_Branch, so the note stays empty.
    var webNote = centre === "online" ? "Online Video Consultation" : "";

    var completeFormData = Object.assign(
      {
        name: fullName,
        phone: phoneRaw,
        email: email,
        helpCategory: HELP_CATEGORY,
        otherConcerns: webNote,
        centre: branchValue,
        centreLabel: centreLabel,
        centreKey: centre,
        consent: true,
      },
      trackingData,
      {
        timestamp: new Date().toISOString(),
        formSubmissionTime: new Date().toISOString(),
        timeToSubmit: Math.round(
          (Date.now() - new Date(trackingData.formOpenedTime).getTime()) / 1000
        ),
      }
    );

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.textContent = "Submitting...";
      submitBtn.disabled = true;
    }

    // GTM event — same shape as the sitewide popup
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "lead_form_submission",
      event_category: "lead",
      event_label: FORM_NAME,
      form_name: FORM_NAME,
      user_name: completeFormData.name,
      user_phone: completeFormData.phone,
      health_concern: HELP_CATEGORY,
      centre: centreLabel,
      traffic_source: trackingData.trafficSource,
      device_type: trackingData.deviceType,
      country: trackingData.country,
      value: 1,
      currency: "INR",
    });

    try {
      localStorage.setItem("yuvrit_lead_submitted", "true");
    } catch (err) {
      /* private mode */
    }

    // Bigin payload — identical field names to the sitewide popup, plus formName
    var biginPayload = {
      formName: FORM_NAME,
      name: completeFormData.name || "Website Lead",
      phone: completeFormData.phone || "",
      email: completeFormData.email || "",
      helpCategory: HELP_CATEGORY,
      otherConcerns: webNote,
      centre: branchValue,
      pageUrl: trackingData.pageUrl || "",
      referrer: trackingData.referrer || "",
      city: trackingData.city || "",
      trafficSource: trackingData.trafficSource || "",
      gaClientId: trackingData.gaClientId || "",
      gclid: trackingData.gclid || "",
      fbclid: trackingData.fbclid || "",
      utmSource: trackingData.utmSource || "",
      utmMedium: trackingData.utmMedium || "",
      campaignName: trackingData.utmCampaign || "",
      adSetName: trackingData.utmContent || "",
    };

    // 1) Google Sheet (optional — paste the Apps Script URL in section settings)
    if (SHEET_ENDPOINT) {
      fetch(SHEET_ENDPOINT, {
        method: "POST",
        body: JSON.stringify(completeFormData),
        keepalive: true,
      }).catch(function (err) {
        console.error("Google Sheet submission:", err);
      });
    }

    // 2) Bigin CRM
    fetch(BIGIN_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(biginPayload),
      keepalive: true,
    }).catch(function (err) {
      console.error("Bigin submission:", err);
    });

    try {
      sessionStorage.setItem(
        "yuvritLead",
        JSON.stringify({ centre: centre, name: fullName, phone: phoneRaw })
      );
    } catch (err) {
      /* private mode */
    }

    window.location.href =
      THANK_YOU_URL +
      "?centre=" + encodeURIComponent(centre) +
      "&name=" + encodeURIComponent(fullName) +
      "&phone=" + encodeURIComponent(phoneRaw) +
      "&category=" + encodeURIComponent(HELP_CATEGORY);
  }

  /* ==========================================================
     THANK-YOU PAGE
     ========================================================== */

  function formatPhone(digits) {
    return "+91 " + digits.slice(0, 5) + " " + digits.slice(5);
  }

  function isPriorityHoursIST() {
    var parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).formatToParts(new Date());
    var hour = Number(parts.find(function (p) { return p.type === "hour"; }).value);
    var minute = Number(parts.find(function (p) { return p.type === "minute"; }).value);
    var mins = hour * 60 + minute;
    return mins >= 9 * 60 + 30 && mins < 18 * 60;
  }

  function initThankYou() {
    var centreKey = new URLSearchParams(window.location.search).get("centre");
    if (!centreKey) {
      try {
        centreKey = JSON.parse(sessionStorage.getItem("yuvritLead") || "{}").centre;
      } catch (err) {
        centreKey = "";
      }
    }

    var centre = CENTRES[centreKey] || CENTRES.hsr;
    var formatted = formatPhone(centre.phone);
    var priority = document.getElementById("priorityBlock");
    var afterHours = document.getElementById("afterHoursBlock");
    if (!priority || !afterHours) return;

    if (isPriorityHoursIST()) {
      priority.hidden = false;
      afterHours.hidden = true;
      document.getElementById("centreLabel").textContent =
        (centre.short || centre.name) + ": " + formatted;
      var callBtn = document.getElementById("callBtn");
      callBtn.href = "tel:+91" + centre.phone;
      callBtn.textContent = "Call " + (centre.short || centre.name) + " · " + formatted;
    } else {
      priority.hidden = true;
      afterHours.hidden = false;
      document.getElementById("fromNumber").textContent = formatted;
    }
  }

  function boot() {
    if (document.getElementById("leadForm")) initLanding();
    if (document.getElementById("priorityBlock")) initThankYou();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();